import React, { useState } from "react";
import cssClasses from "./Settings.module.css";
import { Tab, Tabs } from "@mui/material";
import Settings from "../../Components/Settings/Settings";
import KYCAgreementForm from "../../Components/KYCAgreementForm/KYCAgreementForm";
import RegenerationSettings from "../../Components/Settings/RegenerationSettings/RegenerationSettings";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const SettingsPage = () => {
  const loggedInUser = useSelector((state) => state.Auth.user);
  const [tabValue, setTabValue] = useState();
  const [tabs, setTab] = useState([]);
  const tabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    const payload = []
    if (loggedInUser?.roleId?.level == 1 || loggedInUser?.roleId?.accessibleTabs?.["Settings"]?.["Settings"]?.isAccessible) {
      payload.push("Settings");
    }
    if (loggedInUser?.roleId?.level == 1 || loggedInUser?.roleId?.accessibleTabs?.["Settings"]?.["Masters"]?.isAccessible) {
      payload.push("Masters");
    }
    // Regeneration settings are admin-only (super admin by default; or grant via
    // accessibleTabs.Settings.Regeneration).
    if (loggedInUser?.roleId?.level == 1 || loggedInUser?.roleId?.accessibleTabs?.["Settings"]?.["Regeneration"]?.isAccessible) {
      payload.push("Regeneration");
    }
    setTab(payload)
    setTabValue(payload[0])
  },[loggedInUser])

  const tabList = tabs.map((each, index) => {
    return (
      <Tab
        label={each}
        key={index}
        value={each}
        sx={[
          {
            fontFamily: "Inter-Medium !important",
            fontStyle: "normal !important",
            fontWeight: "500 !important",
            fontSize: "1.4rem !important",
            lineHeight: "2rem !important",
            textTransform: "none !important",
          },
        ]}
      />
    );
  });
  return (
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.wrapperHeader}>
        <div className={cssClasses.title}>Settings</div>
        <Tabs
          value={tabValue}
          onChange={tabChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          sx={[
            {
              borderBottom: "1px solid #EAECF0 !important",
            },
          ]}
        >
          {tabList}
        </Tabs>

        <div className={cssClasses.wrapperContent}>
        {tabValue === "Settings" && (
            <Settings />
        )}
        {tabValue === "Masters" && (
            <KYCAgreementForm />
        )}
        {tabValue === "Regeneration" && (
            <RegenerationSettings />
        )}
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
